import { Dialog, DialogContent } from "~/components/ui/dialog";
import getAppImg from "~/assets/get-app.png";
import blidzQrImg from "~/assets/blidz-qr.png";

export default function GetApp({ open, onOpenChange }: { open: boolean; onOpenChange: (open: boolean) => void }) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent id="get-app-dialog" className="bg-opacity-0 border-none p-0" showCloseButton={false}>
        <div className="flex h-[90dvh] w-full flex-col items-center justify-start gap-6 overflow-hidden rounded-2xl bg-white">
          <img src={getAppImg} alt="Get Blidz App" className="w-full" />
          <img src={blidzQrImg} alt="Blidz QR Code" className="h-32 w-32" />
          <p className="text-sm font-bold">Scan code to get your rewards in app</p>
        </div>
      </DialogContent>
    </Dialog>
  );
}
